module.exports = __webpack_public_path__ + "img/cari.0c0047a1.png";